export default __webpack_public_path__ + "static/404-static-image-7ef27544da85ccd3ce86e4e3aab47280.png";